module.exports = __webpack_public_path__ + "img/SES_235415005.84bf4a8d.jpg";